"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  INCLUDED_PAGES: 'includedPages',
  EXCLUDED_PAGES: 'excludedPages',
  BLOG_POST: 'blog-post',
  SITE_PAGE: 'site_page',
  LANDING_PAGE: 'landing-page',
  KNOWLEDGE_ARTICLE: 'knowledge-article',
  BLOG_LISTING_PAGE: 'blog-listing-page',
  CONTENT_OPTIONS: 'contentOptions',
  PRIORITY_OPTIONS: [{
    langkey: 'marketing.pages.sitemaps.priorityOptions.ten',
    value: '1.0'
  }, {
    langkey: 'marketing.pages.sitemaps.priorityOptions.nine',
    value: '0.9'
  }, {
    langkey: 'marketing.pages.sitemaps.priorityOptions.eight',
    value: '0.8'
  }, {
    langkey: 'marketing.pages.sitemaps.priorityOptions.seven',
    value: '0.7'
  }, {
    langkey: 'marketing.pages.sitemaps.priorityOptions.six',
    value: '0.6'
  }, {
    langkey: 'marketing.pages.sitemaps.priorityOptions.five',
    value: '0.5'
  }, {
    langkey: 'marketing.pages.sitemaps.priorityOptions.four',
    value: '0.4'
  }, {
    langkey: 'marketing.pages.sitemaps.priorityOptions.three',
    value: '0.3'
  }, {
    langkey: 'marketing.pages.sitemaps.priorityOptions.two',
    value: '0.2'
  }, {
    langkey: 'marketing.pages.sitemaps.priorityOptions.one',
    value: '0.1'
  }, {
    langkey: 'marketing.pages.sitemaps.priorityOptions.zero',
    value: '0.0'
  }],
  FREQUENCY_OPTIONS: [{
    langkey: 'marketing.pages.sitemaps.frequencyOptions.always',
    value: 'always'
  }, {
    langkey: 'marketing.pages.sitemaps.frequencyOptions.hourly',
    value: 'hourly'
  }, {
    langkey: 'marketing.pages.sitemaps.frequencyOptions.daily',
    value: 'daily'
  }, {
    langkey: 'marketing.pages.sitemaps.frequencyOptions.weekly',
    value: 'weekly'
  }, {
    langkey: 'marketing.pages.sitemaps.frequencyOptions.monthly',
    value: 'monthly'
  }, {
    langkey: 'marketing.pages.sitemaps.frequencyOptions.yearly',
    value: 'yearly'
  }, {
    langkey: 'marketing.pages.sitemaps.frequencyOptions.never',
    value: 'never'
  }]
};
exports.default = _default;
module.exports = exports.default;